import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const getPassengers = createAsyncThunk(
  'passengers/getPassengers',
  catchAsync(async ({ page, limit, search, startDay, endDay }, thunkAPI) => {
    let params = `${page && limit ? `page=${page}&limit=${limit}` : ''}${search ? `&search=${search}` : '' }`;
    // Додаємо фільтрацію по датах
    if (startDay) params += `&startDay=${startDay}`;
    if (endDay) params += `&endDay=${endDay}`;
    if (params) params = `?${params}`;

    const res = await axios.get(`/passengers${params}`);
    return res.data;
  })
);
